/*
  data:请求数据
  type:请求体 以什么格式传输
*/
export default function (data: any, dataType: string): any {
  let transformData: any;
  switch (dataType.toLowerCase()) {
    case "json":
      transformData = data;
      break;
    case "formdata":
      transformData = new FormData();
      for (const key in data) {
        transformData.append(key, data[key]);
      }
      break;
  }
  return transformData;
}
